import Vimeo from '@vimeo/player';

export default class VimeoPlayer {
	constructor(el) {
		// DOM elements
		this.el = el;
		this.playButton = this.el.querySelector('[data-play-video]');
		this.overlay = this.el.querySelector('[data-video-overlay]');

		// Event listeners
		this.playButton.addEventListener('click', (e) => {
			this.createPlayer();
		});

		// State
		this.loading = false;
		this.videoCreated = false;
	}

	createPlayer() {
		if (this.loading || this.videoCreated) {
			return;
		}

		this.loading = true;
		this.el.classList.add('is-loaded');

		const videoEl = this.el.querySelector('[data-video]');
		videoEl.tabIndex = 0;

		this.player = new Vimeo(videoEl, {
			url: this.el.dataset.videoPlayer,
			autoplay: true,
		});

		this.player.ready().then(() => {
			this.loading = false;
			this.videoCreated = true;
			videoEl.focus();
		});
	}
}
